import React from 'react';
import { Field, FormFooter } from '@atlaskit/form';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { ENABLE_GLP_BILL_ESTIMATION, ENABLE_MANAGE_SUBSCRIPTION_BULK_EDIT } from '@atlassian/cssxp-utils-generic';
import { isStatuspage } from '@atlassian/cssxp-utils-product';
import { useFeatureToggle } from '@css-xp/base';
import { BillEstimateOrderItemDto } from '@css-xp/common-services/src/api/gateways/ccp-gateways/src/ccp-api-order';
import { GlpPriceDifferenceContent } from './glp-price-difference-content';
import { PriceDifferenceContent } from './price-difference-content';
import './price-difference.scss';
import classNames from 'classnames';

export type Estimate = {
  response?: {
    estimate: BillEstimateOrderItemDto;
    linkedEstimates?: BillEstimateOrderItemDto[];
  };
  error?: any;
  loading?: boolean;
};

type PriceDifferenceProps = {
  currentEstimatedBill?: number;
  estimatedBill: Estimate;
  setGrandTotal?: (value: number) => void;
  isBillingCycleChanged?: boolean;
  entitlement: EntitlementDetails;
  isLoading?: boolean;
  renderDetailsAccordion?: boolean;
};

export const PriceDifference = ({
  currentEstimatedBill = 0,
  estimatedBill,
  setGrandTotal,
  isBillingCycleChanged,
  entitlement,
  isLoading = false,
  renderDetailsAccordion = false,
}: PriceDifferenceProps) => {
  const [isEnabled] = useFeatureToggle();
  const isStatuspageProduct = isStatuspage(entitlement?.productId);
  // flag to display glp values instead of bill estimate values
  const isGLPEstimationEnabled =
    isEnabled(ENABLE_GLP_BILL_ESTIMATION) &&
    isEnabled(ENABLE_MANAGE_SUBSCRIPTION_BULK_EDIT) &&
    isBillingCycleChanged &&
    !isStatuspageProduct;

  const isEstimateLoading = !!estimatedBill?.loading || isLoading;

  return (
    <div
      className={classNames('bill-estimate-price-difference', {
        'shade-out': renderDetailsAccordion,
      })}
    >
      <FormFooter align="end">
        <div className="price-tag">
          <Field label={'Next price estimate'} name="nextPriceEstimate" id="nextPriceEstimate">
            {() =>
              isGLPEstimationEnabled ? (
                <GlpPriceDifferenceContent
                  isLoading={isEstimateLoading}
                  billEstimate={estimatedBill.response?.estimate || null}
                  linkedEntitlementsBillEstimate={estimatedBill.response?.linkedEstimates}
                  currentEstimatedBill={currentEstimatedBill}
                  setGrandTotal={setGrandTotal}
                  renderDetailsAccordion={renderDetailsAccordion}
                />
              ) : (
                <PriceDifferenceContent
                  isLoading={isEstimateLoading}
                  billEstimate={estimatedBill.response?.estimate}
                  linkedEntitlementsBillEstimate={estimatedBill.response?.linkedEstimates}
                  currentEstimatedBill={currentEstimatedBill}
                  setGrandTotal={setGrandTotal}
                  renderDetailsAccordion={renderDetailsAccordion}
                />
              )
            }
          </Field>
        </div>
      </FormFooter>
    </div>
  );
};
